// extracted by mini-css-extract-plugin
module.exports = {"Container":"TechSetting_Container__2BAAT","Heading":"TechSetting_Heading__1c_8g"};